// extracted by mini-css-extract-plugin
export var contentBody = "_8j-9";
export var headerImage = "_8j-2";
export var imageButton = "_8j-7";
export var imageButtonIcon = "_8j-8";
export var imageHeader = "_8j-4";
export var imageHeaderText = "_8j-5";
export var imageOverlay = "_8j-3";
export var imageTitle = "_8j-6";
export var imageWrapper = "_8j-1";
export var taskList = "_8j-a";
export var widget = "_8j-0";